import {v4 as uuid } from 'uuid';
import {
    persistAuth,
    getAuthData,
} from './api';

import {
    isTokenOk,
    // expiredToken,
} from './tokenUtil';


function getAuth () {
    const  {
        token,
        payload,
        refreshToken,
    } = getAuthData();

    this.token = token;
    this.payload = payload;
    this.refreshToken = refreshToken;

   
}

function updateAuthInfo ( { token , payload, refreshToken }) {
    this.token = token;
    this.payload = payload;
    this.refreshToken = refreshToken;
    persistAuth({
        token,
        payload,
        refreshToken,
    });
}


async function authSession () {

    const env = this.env;
    this.getAuth();
    const token = this.token;//  expiredToken();


    if (!token) {
        env.errorsStore.dispatchSessionError();
    }

    const tokenOk = await isTokenOk(token);
    if (tokenOk === false) {
        await this.renew();
    } else {
        this.sessionReady = true;
        this.observed.sessionReady = uuid();
    }
}

const actions = {
    getAuth,
    updateAuthInfo,
    authSession,
};

export default actions;
